import moment from 'moment';
import './notification-item.styles.css';
import { NotificationResponse } from './NotificationResponse';

interface NotificationProps {
	notification: NotificationResponse
}

const NotificationItem = ({ notification }: NotificationProps) => {
	const now = moment();
	const notificationTime = moment(notification.Time);
	const duration = moment.duration(now.diff(notificationTime));

	let formattedTime = '';
	if (duration.asDays() < 1) {
		const hours = Math.floor(duration.asHours());
		const minutes = Math.floor(duration.asMinutes()) % 60;
		if (hours > 0 && minutes > 0) {
			formattedTime = `${hours} hours ${minutes} minutes ago`;
		} else if (hours > 0) {
			formattedTime = `${hours} hours ago`;
		} else {
			formattedTime = `${minutes} minutes ago`;
		}
	} else {
		const days = Math.floor(duration.asDays());
		const hours = Math.floor(duration.asHours()) % 24;
		if (hours > 0) {
			formattedTime = `${days} days ${hours} hours ago`;
		} else {
			formattedTime = `${days} days ago`;
		}
	}
	return (
		<div className="notification-item">
			<div className="notification-avatar">{notification.Initial}</div>
			<div className="notification-message">
				<span className="notification-time">{formattedTime}</span>
				<p>{notification.Message}</p>
			</div>

		</div>
	);
};

export default NotificationItem;
